import { toast } from "react-toastify";
import { stringConstant, toast_options } from "../../utils/constants";
import {fms_fleet, get_fleet} from "../../utils/webAPIs";
import axios from "axios";
import { GET_CAR_LIST, SET_LOADING } from "../type";
import {BACKEND_URL, FMS_BACKEND_URL} from "../../utils/config";

export const getCarList = (dispatch) => {
  axios
    .get(`${BACKEND_URL}${get_fleet}`)
    .then((res) => {
      if (res.status === 200) {
        const { categories, vehicles } = res.data;
        const result = categories.map((category) => ({
          ...category,
          vehicles: vehicles.filter(
            (vehicle) => vehicle.category === category.id
          ),
        }));
        console.log(categories, vehicles, result)
        // dispatch({ type: GET_CAR_LIST, payload: result });
      } else {
        toast.error(stringConstant.failed_register, toast_options);
      }
      dispatch({ type: SET_LOADING, payload: false });
    })
    .catch((err) => console.log(err));
};

export const getFleetCarList = (dispatch) => {
  axios
    .get(`${FMS_BACKEND_URL}${fms_fleet}`)
    .then((res) => {
      if (res.status === 200) {
          console.log(res)
        const { vehicleTypes, vehicles } = res.data.data;
        const result = vehicleTypes.map((category) => ({
          ...category,
          vehicles: vehicles.filter(
            (vehicle) => vehicle.type_id === category.id
          ),
        }));
        console.log(result);
        dispatch({ type: GET_CAR_LIST, payload: result });
      } else {
        toast.error(stringConstant.failed_register, toast_options);
      }
      dispatch({ type: SET_LOADING, payload: false });
    })
    .catch((err) => console.log(err));
};
